import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  setGlobalFields,
  setGlobalDefaultValues,
} from '@kaidam/fc-shared/src/frontend/components/form/utils'

import fields, { defaultValues } from './components/form/fields'
import Router from './router'
import routes from './router/routes'
import Store from './store'

import {
  isDevelopment,
} from '@kaidam/fc-shared/src/utils/settings'

import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"
import LogRocket from 'logrocket'

setGlobalFields(fields)
setGlobalDefaultValues(defaultValues)

// use to save the state to local storage for
// quick debugging of redux
if(isDevelopment()) {
  (window as any).__saveState = () => {
    const data = JSON.stringify(store.getState(), null, 4)
    localStorage.setItem('fc_state', data)
  }
  
  (window as any).__clearState = () => {
    localStorage.removeItem('fc_state')
  }

  const existingData = localStorage.getItem('fc_state')

  if(existingData) {
    // we need to adjust a few things in the loaded state
    // otherwise we don't go through the initialise phase on page load
    const parsedData = JSON.parse(existingData)
    const w = window as any
    parsedData.system.initialised = false
    w.__INITIAL_STATE__ = parsedData
  }
}
else {
  Sentry.init({
    dsn: "https://d2933b5bcf5445028b1daa1ed1461b36@o1078632.ingest.sentry.io/6082671",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
  LogRocket.init('franchise-cloud/franchise-cloud')
}

const initialState: Record<string, any> = (window as any).__INITIAL_STATE__ || {}

const router = Router(routes)

const store = Store({
  router,
  initialState,
})

const rootEl = document.querySelector('#root')

let render = () => {
  const RootAppComponent = require('./root').default
  const root = createRoot(rootEl)
  root.render(
    <RootAppComponent
      store={ store }
      router={ router }
    />
  )
}

render()
